import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager,
    TouchableHighlight

} from "react-native"
import {moderateScale} from "../../tools/Scaling";
import Colors from "../../tools/Colors";
import HMIcon from "../HMIcon";
import HMTextView from "../HMTextView";
import i18n from "../../I18n/i18n";
import HMLightbox from "../lightbox/HMLightbox";
import {Tools} from "../../tools/Tools";
import PathFile from "../../assets/PathFile";
import HMTextInput from "../HMTextInput";
import HMVideo from "../video/HMVideo";
import HMVoicePlayer from "../voice/HMVoicePlayer";
import HMSelectInput from "../HMSelectInput";
import {RequestApi} from "../../api/RequestApi";
import HMRecordAudio from "../record/audio/HMRecordAudio";

import HMModalSelectFiles from "../selectFiles/HMModalSelectFiles";
import HMLabel from "../label/HMLabel";
import DialogLoadingCustomize from "../DialogLoadingCustomize";
//import HMFiles from "../file/HMFiles";
import HMFilesTest from "../file/HMFilesTest";
import FloatingMenu from "../fabMenu/components/FloatingMenu";
import * as NavigationService from "../../redux/NavigationService";
import HMAlert from "../HMAlert";
import Toast from "../toast";
import connect from "react-redux/es/connect/connect";


let descriptionValue = null;
let stream = null;
let container = null;
const audioType = 'audio/webm';
const items = [
    {
        // label: 'Do a little dance',
        icon: "message",
        typeIcon: "Entypo",
        type: 1,
    }, {
        // label: 'Do a little dance',
        icon: "check",
        typeIcon: "Entypo",
        type: 2,
    },

];

class HMBottomBarItemSatiaOperator extends Component {
    constructor(props) {
        super(props);
        container = this;
        this.state = {
            min: null,
            max: null,
            size: null,

            Modalcategory: false,
            pickedcategory: null,

            visibleCategoryType: false,
            pickedCategoryType: null,

            visibleModal: '',

            ShowImage: props.stateParent && props.stateParent.pathImage,

            pathImage: null,
            pathImageVideo: PathFile.image.PlayVideo,
            pathVideo: null,
            ShowAudio: null,
            index: 0,

            checked: false,
            pathCompress: null,


            currentTime: 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            audioPath: null,
            //   audioPath: null,
            hasPermission: undefined,
            prepareRecord: true,


            playState: 'record', //playing, paused ,record , stop
            duration: 0,

            arrImage: props.stateParent && props.stateParent.arrImage ? props.stateParent.arrImage : [],
            alaki: false,
            audioURL: null,
            showMessageInput: null,
            onPressStatusVoice: false,
            recordState: null,
            isLoading: false,

            listName: [],

            isMenuOpen: false,
            taskType: "doing",

        }

        this._setStateData = this._setStateData.bind(this);

    }

    handleMenuToggle = isMenuOpen =>
        this.setState({isMenuOpen});

    handleItemPress = (item, index) => {
    }

    componentWillReceiveProps(props) {


    }

    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }


    async onShow(data, func) {
        func ? func() : null;
        // if (data === 'selectaudio') {
        //     this.setState({
        //         visibleModal: data,
        //         Modalcategory: true,
        //         //    audioPath: p,
        //     });
        //
        // }
        // else
        container.setState({
            visibleModal: data,
            Modalcategory: true,
            //    audioPath: p,
        });
    }

    _setStateData(object) {
        container.setState(object);
    }

    hiddenModal(func = null) {
        func ? func() : null
        container.setState({
                visibleModal: ''
            },
            async () => {
                // this.state.recording?   await this._stopWeb():null
            }
        )
    }

    render() {
        const {
            funcSwitch, onPress, styleRoot, style, text, numberOfLines, type, cammas, noFont, onValueChangeSelectInput,
            _setStateData,
            itemExtra,
            resultsExtra,

            onValueChangeSelectInputRoll,
            valueSelectInputRoll,
            indexSelectInputRoll,
            itemSelectInputRoll,
            optionsSelectInputRoll,

            listNameCCTask,
            onValueChangeSelectInputCCTask,
            valueSelectInputCCTask,
            indexSelectInputCCTask,
            itemSelectInputCCTask,
            optionsSelectInputCCTask,
            onPressListNameCCTask,
            FloatingActionButton
        } = this.props;

        let {listName} = this.state;
        let checkSeconds = (this.state.currentTime > 0 && this.state.currentTime < 60);
        let width_item = moderateScale(300);

        let listUser = resultsExtra && resultsExtra.listUser ? resultsExtra.listUser : [];
        // let categoryTask = resultsExtra && resultsExtra.categoryTask ? resultsExtra.categoryTask : [];
        // let categoryPriority = resultsExtra && resultsExtra.categoryPriority ? resultsExtra.categoryPriority : [];
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        return (
            <View
                style={false && (this.state.isLoadingCompress || this.state.showMessageInput) ? {
                        position: 'absolute',
                        top: moderateScale(48),
                        bottom: 0,
                        right: 0,
                        left: 0,
                        zIndex: 9900,
                        justifyContent: "flex-end",

                        //   alignItems: "flex-end",
                        //  justifyContent: "flex-end",
                        //   backgroundColor: 'rgba(0,0,0,0.7)',
                    }
                    :
                    {}
                }
            >
                <TouchableHighlight
                    style={false && (this.state.isLoadingCompress || this.state.showMessageInput) ? {
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            right: 0,
                            left: 0,
                            zIndex: 9900,

                            backgroundColor: 'rgba(0,0,0,0.7)',
                        }
                        :
                        {}
                    }
                    onPress={() => {
                        this.setState({
                            showMessageInput: false
                        })

                    }}
                >
                    <View/>

                </TouchableHighlight>
                <View
                    style={false && (this.state.isLoadingCompress || this.state.showMessageInput) ? {
                            position: 'absolute',
                            //top: moderateScale(48),
                            bottom: 0,
                            right: 0,
                            left: 0,
                            zIndex: 9901,
                            //   alignItems: "flex-end",
                            //   backgroundColor: 'rgba(0,0,0,0.7)',
                        }
                        :
                        {}
                    }
                >
                    {
                        true || this.state.showMessageInput ?

                            <View
                                style={[{width: "100%", backgroundColor: Colors.white}
                                    // , this.state.showMessageInput ? {
                                    //     position: 'absolute',
                                    //     bottom: moderateScale(50),
                                    //     backgroundColor:Colors.white
                                    //
                                    // } : {}

                                ]}>
                                {
                                    false && (!FloatingActionButton && (this.state.pathImage || this.state.pathVideo || this.state.ShowAudio)) ?
                                        <View
                                            style={[{
                                                width: "100%",
                                                height: moderateScale(this.state.ShowAudio ? 48 : 280),
                                                // margin: moderateScale(4),
                                                backgroundColor: Colors.black,
                                            },
                                                this.state.pathVideo ? {
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                } : {}
                                            ]}
                                        >
                                            {
                                                // this.state.pathImage?
                                                //     <HMLightbox
                                                //         uri={URL.createObjectURL(this.state.pathImage)}/>
                                                //         :
                                                //     <HMVideo path={URL.createObjectURL(this.state.pathVideo)}/>
                                                //  {/*<HMLightbox uri={URL.createObjectURL(this.state.pathImage)}/>*/}
                                                this.SwitchFile()
                                            }
                                        </View>
                                        :
                                        null


                                }

                                <View
                                    style={{
                                        width: "100%",
                                        // height: moderateScale(48),
                                        maxHeight: moderateScale(140),
                                        flexDirection: "row",
                                        backgroundColor: Colors.white,
                                        alignItems: 'center',
                                        //justifyContent: 'center',
                                        //paddingHorizontal:moderateScale(4),
                                        // marginVertical: moderateScale(2),
                                    }}>
                                    {
                                        this.state.taskType == "done" || ((this.state.pathImage && this.state.pathImage.length > 0) || (this.state.pathVideo) || (this.state.ShowAudio) || (this.state.description && this.state.description.length > 0) && !this.state.isLoading) ?
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.setState((this.state.pathImage) ? {description: descriptionValue} : {},

                                                        () => {
                                                            this.setData()
                                                        })
                                                }}

                                                style={{

                                                    width: moderateScale(44),
                                                    height: moderateScale(44),
                                                    // backgroundColor: '#ee005b',
                                                    //position: 'absolute',
                                                    borderRadius: moderateScale(22),
                                                    //  borderColor: Colors.blue,
                                                    // borderWidth: moderateScale(1),
                                                    margin: moderateScale(4),
                                                    //  top: 0,
                                                    //  left: 0,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    alignSelf: "center",

                                                }}>
                                                <HMIcon
                                                    // type={""}
                                                    name={this.state.taskType == "done" ? "checkmark-circle" : "send"}
                                                    style={{
                                                        textAlign: 'center',
                                                        //alignSelf: 'flex-end',
                                                        color: this.state.taskType == "done" ? Colors.green : Colors.colorPrimary,
                                                        // width: moderateScale(32),
                                                        // height: moderateScale(32),
                                                        fontSize: moderateScale(32)
                                                    }}/>
                                                {/* <HMTextView

                                                // type={"bold"}
                                                noFont={!I18nManager.isRTL}
                                                style={{
                                                    fontSize: moderateScale(12),
                                                    color: Colors.blue,
                                                    margin: moderateScale(6)

                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={"ارسال"}
                                                styleRoot={{}}
                                            />*/}
                                            </TouchableOpacity>
                                            :
                                            null
                                    }
                                    <HMTextInput
                                        //  _ref={(ref) => this.valueRef = ref}
                                        onRef={(ref) => {
                                            this.valueRef = ref?.textInput
                                        }}
                                        value={(this.state.pathImage) ? descriptionValue : this.state.description}
                                        number
                                        onChangeText={text => {

                                            if (this.state.pathImage) {
                                                descriptionValue = text;

                                            }
                                            else {
                                                this.setState({description: text})
                                                //  console.log("text1", text, this.state.pathImage, descriptionValue)

                                            }
                                        }}
                                        onPressClear={() => {

                                            descriptionValue = null;
                                            this.setState({description: null})
                                            this.valueRef.clear()
                                        }}
                                        // _height={moderateScale(100)}
                                        //   keyboardType="numeric"
                                        placeholder={i18n.t('constant.PlaceholderDesc')}
                                        style={{
                                            height: moderateScale(80),
                                            // maxHeight: moderateScale(100),
                                            // minHeight: moderateScale(48),
                                            fontSize: moderateScale(14)
                                        }} underlineColorAndroid="transparent"
                                        //  styleInput={{height: moderateScale(80)}}
                                        styleRoot={{flex: 1}}
                                        // textCenter={'center'}
                                        onSubmitEditing={() => {
                                            if (((this.state.pathImage) || (this.state.description && this.state.description.length > 0)) && !this.state.isLoading)
                                                this.setState((this.state.pathImage) ? {description: descriptionValue} : {},

                                                    () => {
                                                        this.setData()
                                                    })
                                        }

                                        }
                                        autoFocus
                                        multiline={true}
                                    />

                                    <TouchableOpacity
                                        //  disabled={this.state.SelectRollValue}
                                        onPress={() => {
                                            this.state.SelectRollValue ? Toast.show({
                                                    // type: 'success | error | info',
                                                    type: 'custom_error',
                                                    //  position: 'top | bottom',
                                                    position: 'top',
                                                    text1: i18n.t('constant.message'),
                                                    text2: "زمانی که ارجاع به انتخاب می نمایید نمی توانید وظیفه را ببندید",
                                                    visibilityTime: 4000,
                                                    autoHide: true,
                                                    //  topOffset: 30,
                                                    // bottomOffset: 40,
                                                    onShow: () => {
                                                    },
                                                    onHide: () => {
                                                    }
                                                })
                                                :
                                                HMAlert(
                                                    i18n.t('constant.message'),
                                                    "آیا میخواهید وظیفه را ببندید؟  ",
                                                    [
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                                this.setState((this.state.pathImage) ? {
                                                                        description: descriptionValue,
                                                                        taskType: "done"
                                                                    } : {taskType: "done"},

                                                                    () => {
                                                                        this.setData()
                                                                    })
                                                            }


                                                        },

                                                    ],
                                                    {cancelable: true}
                                                )

                                        }}

                                        style={{

                                            width: moderateScale(44),
                                            height: moderateScale(44),
                                            // backgroundColor: '#ee005b',
                                            //position: 'absolute',
                                            borderRadius: moderateScale(22),
                                            //  borderColor: Colors.blue,
                                            // borderWidth: moderateScale(1),
                                            margin: moderateScale(4),
                                            //  top: 0,
                                            //  left: 0,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            alignSelf: "center",

                                        }}>
                                        <HMIcon
                                            // type={""}
                                            name={"checkmark-circle"}
                                            style={{
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: this.state.SelectRollValue ? Colors.gray : Colors.green,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(32)
                                            }}/>
                                        {/* <HMTextView

                                                // type={"bold"}
                                                noFont={!I18nManager.isRTL}
                                                style={{
                                                    fontSize: moderateScale(12),
                                                    color: Colors.blue,
                                                    margin: moderateScale(6)

                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={"ارسال"}
                                                styleRoot={{}}
                                            />*/}
                                    </TouchableOpacity>

                                </View>
                                {
                                    !optionsSelectInputRoll || !(itemExtra && !itemExtra.NotAccess) ?
                                        null
                                        :
                                        <View
                                            style={{
                                                flexDirection: "row",
                                                width: "98%",
                                                alignSelf: 'center',
                                                alignItems: "center",
                                                marginVertical: moderateScale(6),
                                            }}>

                                            {
                                                this.state.showSelectInputRollBack ?
                                                    null
                                                    :
                                                    <TouchableOpacity
                                                        style={{
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            marginEnd: moderateScale(6)
                                                        }}
                                                        onPress={() => {
                                                            this.setState({showSelectInputRoll: !this.state.showSelectInputRoll})
                                                            // _setStateData({
                                                            this.setState({
                                                                SelectRollValue: null,
                                                                Roll: {
                                                                    label: i18n.t('constant.SelectItem'),
                                                                    value: -1,
                                                                    index: -1
                                                                }
                                                            });
                                                        }}>
                                                        <HMIcon
                                                            // type={""}
                                                            name={this.state.showSelectInputRoll ? "remove" : "add"}
                                                            style={{
                                                                textAlign: 'center',
                                                                //alignSelf: 'flex-end',
                                                                color: this.state.showSelectInputRoll ? Colors.red : Colors.blue,
                                                                // width: moderateScale(32),
                                                                // height: moderateScale(32),
                                                                fontSize: moderateScale(24)
                                                            }}/>
                                                        <HMTextView

                                                            // type={"bold"}
                                                            noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(12),
                                                                color: this.state.showSelectInputRoll ? Colors.red : Colors.blue,
                                                                margin: moderateScale(2)

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            text={this.state.showSelectInputRoll ? "حذف ارجاع" : "افزودن ارجاع"}
                                                            styleRoot={{}}
                                                        />
                                                    </TouchableOpacity>
                                            }

                                            {
                                                this.state.showSelectInputRoll ?
                                                    null
                                                    :
                                                    <TouchableOpacity
                                                        style={{
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            marginEnd: moderateScale(6)
                                                        }}
                                                        onPress={() => {

                                                            //   let OpRef = itemExtra.OpRef;
                                                            //_setStateData(!this.state.showSelectInputRollBack ? {
                                                            this.setState(!this.state.showSelectInputRollBack ? {
                                                                    SelectRollValue: itemExtra?.CreatorTask?.OpRef,
                                                                    Roll: {
                                                                        //label: itemExtra.CreatorTask.operator + " - " + itemExtra.CreatorTask.Name,
                                                                        label: itemExtra.ReferToTask ? itemExtra.ReferToTask.Name : itemExtra?.CreatorTask?.Name,
                                                                        value: itemExtra.ReferToTask ? itemExtra.ReferToTask.OpRef : itemExtra?.CreatorTask?.OpRef,
                                                                        index: 0
                                                                    }
                                                                }
                                                                :
                                                                {
                                                                    SelectRollValue: null,
                                                                    Roll: {
                                                                        label: i18n.t('constant.SelectItem'),
                                                                        value: -1,
                                                                        index: -1
                                                                    }

                                                                });
                                                            this.setState({showSelectInputRollBack: !this.state.showSelectInputRollBack},)

                                                        }}>
                                                        <HMIcon
                                                            // type={""}
                                                            name={this.state.showSelectInputRollBack ? "remove" : "add"}
                                                            style={{
                                                                textAlign: 'center',
                                                                //alignSelf: 'flex-end',
                                                                color: this.state.showSelectInputRollBack ? Colors.red : Colors.blue,
                                                                // width: moderateScale(32),
                                                                // height: moderateScale(32),
                                                                fontSize: moderateScale(24)
                                                            }}/>
                                                        <HMTextView

                                                            // type={"bold"}
                                                            noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(12),
                                                                color: this.state.showSelectInputRollBack ? Colors.red : Colors.blue,
                                                                margin: moderateScale(2)

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            text={(this.state.showSelectInputRollBack ? "حذف پاسخ به " : "افزودن پاسخ به ") + (itemExtra.ReferToTask ? itemExtra.ReferToTask.Name : itemExtra?.CreatorTask?.Name)}
                                                            styleRoot={{}}
                                                        />
                                                    </TouchableOpacity>
                                            }
                                            {
                                                !this.state.showSelectInputRoll ?
                                                    null
                                                    :
                                                    <View style={{flex: 1, flexDirection: "row", alignItems: "center"}}>
                                                        <HMTextView
                                                            //type={"bold"}
                                                            text={"ارجاع به : "}
                                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                            style={{
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(14),
                                                                //   marginEnd: moderateScale(10),

                                                            }}/>
                                                        <View style={{flex: 1}}>
                                                            <HMSelectInput
                                                                DropdownModal
                                                                // onValueChange={onValueChangeSelectInputRoll}
                                                                // // error={this.state.errorSelectInput}
                                                                // //
                                                                // // //  requestServerRetry={container.getServerTypeDocuments}
                                                                // // requestServer={() => {
                                                                // // }}
                                                                // value={valueSelectInputRoll}
                                                                // index={indexSelectInputRoll}
                                                                // itemSelectInput={itemSelectInputRoll}
                                                                // options={optionsSelectInputRoll}


                                                                onValueChange={(value) => {
                                                                    let idx = listUser.findIndex(obj => obj.value == value);
                                                                    let res = null;
                                                                    if (idx !== -1) {
                                                                        res = listUser[idx]
                                                                    }

                                                                    this.setState({
                                                                        SelectRollValue: value,
                                                                        Roll: res ? {
                                                                            ...res,
                                                                            index: idx
                                                                        } : {
                                                                            label: i18n.t('constant.SelectItem'),
                                                                            value: idx,
                                                                            index: idx
                                                                        }
                                                                    })
                                                                }}
                                                                value={this.state.SelectRollValue ? "" : i18n.t('constant.SelectItem')}
                                                                index={this.state.Roll ? this.state.Roll.index : -1}
                                                                itemSelectInput={this.state.Roll}
                                                                options={listUser ? listUser : []}

                                                                styleRoot={{
                                                                    width: '100%'
                                                                }}
                                                            />
                                                        </View>
                                                    </View>
                                            }
                                        </View>
                                }
                                {
                                    !optionsSelectInputCCTask || !(itemExtra && !itemExtra.NotAccess) ?
                                        null
                                        :
                                        (

                                            <View style={{width: "100%"}}>
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        width: "98%",
                                                        alignSelf: 'center',
                                                        alignItems: "center",

                                                        //marginVertical: moderateScale(6),
                                                    }}>
                                                    <TouchableOpacity
                                                        style={{
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            marginEnd: moderateScale(6)
                                                        }}
                                                        onPress={() => {
                                                            //  this.setState({showSelectInputCCTask: !this.state.showSelectInputCCTask})
                                                            // _setStateData({
                                                            this.setState({
                                                                showSelectInputCCTask: !this.state.showSelectInputCCTask,
                                                                listName: [],
                                                                SelectCCTaskValue: null,
                                                                CCTask: {
                                                                    label: i18n.t('constant.SelectItem'),
                                                                    value: -1,
                                                                    index: -1
                                                                }
                                                            });
                                                        }}>
                                                        <HMIcon
                                                            // type={""}
                                                            name={this.state.showSelectInputCCTask ? "remove" : "add"}
                                                            style={{
                                                                textAlign: 'center',
                                                                //alignSelf: 'flex-end',
                                                                color: this.state.showSelectInputCCTask ? Colors.red : Colors.blue,
                                                                // width: moderateScale(32),
                                                                // height: moderateScale(32),
                                                                fontSize: moderateScale(24)
                                                            }}/>
                                                        <HMTextView

                                                            // type={"bold"}
                                                            noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(12),
                                                                color: this.state.showSelectInputCCTask ? Colors.red : Colors.blue,
                                                                margin: moderateScale(2)

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            text={this.state.showSelectInputCCTask ? "حذف رونوشت" : "افزودن رونوشت"}
                                                            styleRoot={{}}
                                                        />
                                                    </TouchableOpacity>
                                                    {
                                                        !this.state.showSelectInputCCTask ?
                                                            null
                                                            :
                                                            <View style={{
                                                                flex: 1, flexDirection: "row", alignItems: "center",
                                                            }}>

                                                                <View style={{flex: 1}}>
                                                                    <HMSelectInput
                                                                        DropdownModal
                                                                        // onValueChange={onValueChangeSelectInputCCTask}
                                                                        // // error={this.state.errorSelectInputRoll}
                                                                        // //
                                                                        // // //  requestServerRetry={container.getServerTypeDocuments}
                                                                        // // requestServer={() => {
                                                                        // // }}
                                                                        // value={valueSelectInputCCTask}
                                                                        // index={indexSelectInputCCTask}
                                                                        // itemSelectInput={itemSelectInputCCTask}
                                                                        // options={optionsSelectInputCCTask}

                                                                        onValueChange={(value) => {
                                                                            let idx = listUser.findIndex(obj => obj.value == value);
                                                                            let idxListName = this.state.listName.findIndex(obj => obj.value == value);

                                                                            let res = null;
                                                                            var array = this.state.listName;
                                                                            if (idx !== -1 && idxListName === -1) {
                                                                                res = listUser[idx]
                                                                                array = [...this.state.listName]; // make a separate copy of the array
                                                                                array.push(res);
                                                                            }
                                                                            this.setState({
                                                                                listName: array,
                                                                                SelectCCTaskValue: value,
                                                                                CCTask: res ? {
                                                                                    ...res,
                                                                                    index: idx
                                                                                } : {
                                                                                    label: i18n.t('constant.SelectItem'),
                                                                                    value: idx,
                                                                                    index: idx
                                                                                }
                                                                            })
                                                                        }}

                                                                        value={this.state.SelectCCTaskValue ? "" : i18n.t('constant.SelectItem')}
                                                                        index={this.state.CCTask ? this.state.CCTask.index : -1}
                                                                        itemSelectInput={this.state.CCTask}
                                                                        options={listUser ? listUser : []}
                                                                        //  listNameCCTask={listName ? listName : []}


                                                                        styleRoot={{
                                                                            width: '100%'
                                                                        }}
                                                                    />

                                                                </View>
                                                            </View>
                                                    }


                                                </View>
                                                {
                                                    this.state.showSelectInputCCTask && listName && listName.length > 0 ?
                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                width: "98%",
                                                                alignSelf: 'center',
                                                                alignItems: "center",

                                                                //marginVertical: moderateScale(6),
                                                            }}>
                                                            <HMTextView
                                                                //type={"bold"}
                                                                // text={"رونوشت به : " + `( ${(listNameCCTask && listNameCCTask.length ? listNameCCTask.length : 0)} ) `}
                                                                text={"رونوشت به : " + "\n" + `( ${(listName && listName.length ? listName.length : 0)} ) `}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14),
                                                                    textAlign: "center",
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                            <View
                                                                style={{
                                                                    //position:'absolute',
                                                                    flexDirection: "row",
                                                                    flexWrap: 'wrap',
                                                                    flex: 1,
                                                                    //  width: "100%",
                                                                    flexGrow: 1,
                                                                    alignItems: 'center',
                                                                    //justifyContent: 'center',
                                                                    //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                                                    //  backgroundColor: "#876a79",
                                                                }}>
                                                                {
                                                                    listName.map((item, index) => {
                                                                        return <View
                                                                            onPress={() => {

                                                                            }
                                                                            }
                                                                            style={{
                                                                                paddingHorizontal: moderateScale(3),
                                                                                backgroundColor: Colors.colorSecondPrimary,
                                                                                borderRadius: moderateScale(4),
                                                                                marginHorizontal: moderateScale(2),
                                                                                marginVertical: moderateScale(2),
                                                                            }}
                                                                        >
                                                                            <View style={[{
                                                                                //marginVertical: moderateScale(15),
                                                                                height: moderateScale(30),
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                flexDirection: 'row'
                                                                            }]}>
                                                                                {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                                                                                {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                                                                                <HMTextView text={item.label}
                                                                                            type={"bold"}
                                                                                            style={{
                                                                                                color: Colors.blackLight,
                                                                                                marginHorizontal: moderateScale(6),
                                                                                                fontSize: moderateScale(11),
                                                                                                textAlign: 'center'
                                                                                            }}/>
                                                                                {
                                                                                    <TouchableOpacity
                                                                                        onPress={() => {
                                                                                            var array = [...this.state.listName]; // make a separate copy of the array

                                                                                            if (this.state.SelectCCTaskValue === this.state.listName[index].value) {
                                                                                                this.setState({
                                                                                                    SelectCCTaskValue: -1,
                                                                                                    CCTask: {
                                                                                                        label: i18n.t('constant.SelectItem'),
                                                                                                        value: -1,
                                                                                                        index: -1
                                                                                                    }
                                                                                                })
                                                                                            }
                                                                                            array.splice(index, 1);
                                                                                            this.setState({listName: array});


                                                                                            /*    let arr= this.state.listName
                                                                                                this.setState({
                                                                                                    listName: arr.splice(index, 1)
                                                                                                })*/
                                                                                        }}
                                                                                        style={{alignSelf: 'center'}}>
                                                                                        <HMIcon name={"md-close"}
                                                                                                style={{
                                                                                                    fontSize: moderateScale(14),
                                                                                                    color: '#0f0f0f'
                                                                                                }}/>
                                                                                    </TouchableOpacity>
                                                                                }


                                                                            </View>
                                                                            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

                                                                        </View>
                                                                    })
                                                                }
                                                            </View>
                                                        </View>
                                                        :
                                                        null
                                                }

                                                {/*       <FlatList
                                                style={{height: moderateScale(30)}}
                                                // data={data.results.all_categories}
                                                data={this.state.listName}
                                                renderItem={({item, index}) =>

                                                    <View
                                                        onPress={() => {

                                                        }
                                                        }
                                                        style={{
                                                            paddingHorizontal: moderateScale(3),
                                                            backgroundColor: Colors.colorSecondPrimary,
                                                            borderRadius: moderateScale(4),
                                                            marginHorizontal: moderateScale(2)
                                                        }}
                                                    >
                                                        <View style={[{
                                                            //marginVertical: moderateScale(15),
                                                            height: moderateScale(30),
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexDirection: 'row'
                                                        }]}>
                                                            <HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}
                                                            style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/>
                                                            <HMTextView text={item.label} type={"bold"}
                                                                        style={{
                                                                            color: Colors.blackLight,
                                                                            marginHorizontal: moderateScale(6),
                                                                            fontSize: moderateScale(11),
                                                                            textAlign: 'center'
                                                                        }}/>
                                                            <TouchableOpacity
                                                                onPress={() => {
                                                                    var array = [...this.state.listName]; // make a separate copy of the array

                                                                    array.splice(index, 1);
                                                                    this.setState({listName: array});
                                                                }}
                                                                style={{alignSelf: 'center'}}>
                                                                <HMIcon name={"md-close"} style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: '#0f0f0f'
                                                                }}/>
                                                            </TouchableOpacity>


                                                        </View>
                                                    </View>
                                                }
                                                horizontal={true}
                                                showsHorizontalScrollIndicator={false}
                                                keyExtractor={(item, index) => index.toString()}
                                                inverted={true}
                                            />*/}


                                            </View>


                                        )

                                }
                                {
                                    true || (FloatingActionButton && this.state.showMessageInput) ?

                                        <HMFilesTest
                                            stateParent={this.state}
                                            _setStateData={container._setStateData}
                                            _setStateDataParent={container.props._setStateData}
                                            SizeBox={3}
                                            notFirstClear
                                            // styleRoot2={{flexDirection: 'row',}}
                                            clearState={this.clearState}
                                            styleRoot2={{
                                                flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                width: "100%",

                                                // flexGrow: 1,
                                                //  backgroundColor: "#ee04d0",
                                                alignItems: "flex-start"

                                            }}
                                        />
                                        :
                                        null
                                }
                            </View>
                            :
                            null
                    }
                    {
                        FloatingActionButton ?
                            (this.state.showMessageInput ?
                                    null
                                    :
                                    (
                                        1 != 1 ?
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this._setStateData({
                                                        showMessageInput: true
                                                    })
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    //right: 0,
                                                    overflow: 'hidden',
                                                    width: moderateScale(56),
                                                    height: moderateScale(56),
                                                    borderRadius: moderateScale(28),
                                                    // padding: moderateScale(4),
                                                    margin: moderateScale(5),
                                                    borderWidth: moderateScale(1),
                                                    borderColor: '#ddd',
                                                    borderBottomWidth: 0,
                                                    shadowColor: '#000',
                                                    shadowOffset: {width: 0, height: moderateScale(.7)},
                                                    shadowOpacity: 0.6,
                                                    shadowRadius: moderateScale(2),
                                                    elevation: moderateScale(1),
                                                    // marginLeft: moderateScale(1),
                                                    // marginRight: moderateScale(1),
                                                    // marginTop: moderateScale(1),
                                                    // marginBottom: moderateScale(1),
                                                    backgroundColor: Colors.colorSecondPrimary,
                                                    alignItems: 'center',
                                                    justifyContent: "center",
                                                    zIndex: 1,
                                                    display: this.state.showMessageInput ? 'none' : '',
                                                }}>
                                                <HMIcon
                                                    type={"bold"}
                                                    // type={"FontAwesome"}
                                                    name="add" style={{
                                                    color: Colors.white,
                                                    fontSize: moderateScale(28),
                                                    padding: moderateScale(2),
                                                    alignSelf: "center",
                                                }}/>
                                            </TouchableOpacity>
                                            :
                                            <FloatingMenu
                                                isOpen={this.state.isMenuOpen}
                                                items={items}
                                                onMenuToggle={this.handleMenuToggle}
                                                onItemPress={this.handleItemPress}
                                                primaryColor={Colors.colorPrimary}
                                                backgroundUpColor={Colors.colorSecondPrimary}
                                                position={"bottom-left"}
                                                renderItemIcon={this.renderItemIcon}
                                                renderMenuIcon={this.renderMenuIcon}
                                                //    bottom={0}
                                                // left={0}
                                            />
                                    )
                            )
                            :
                            false && <View
                                style={[{
                                    width: "100%",
                                    height: moderateScale(50),


                                    //paddingHorizontal:moderateScale(4),
                                    marginVertical: moderateScale(2),
                                },

                                    //     this.state.isLoadingCompress || this.state.showMessageInput ? {
                                    //     position: 'absolute',
                                    //     bottom: 0,
                                    //
                                    // } : {}

                                ]}>
                                <View
                                    style={{
                                        width: "100%",
                                        height: moderateScale(50),
                                        backgroundColor: Colors.white,
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        borderColor: Colors.blackLight,
                                        // margin:moderateScale(1),
                                        borderWidth: moderateScale(1)
                                    }}>
                                    {/*     <TouchableOpacity
                            onPress={() => {
                                this.start();
                            }}

                            style={{
                                width: moderateScale(44),
                                height: moderateScale(44),
                                // backgroundColor: '#ee005b',
                                //position: 'absolute',
                                borderRadius: moderateScale(22),
                                // borderColor: Colors.gray,
                                // borderWidth: moderateScale(1),
                                margin: moderateScale(4),
                                //  top: 0,
                                //  left: 0,
                                alignItems: 'center',
                                justifyContent: 'center',
                                alignSelf: "center",

                            }}>
                            <AudioReactRecorder state={this.state.recordState} onStop={this.onStop}/>

                        </TouchableOpacity>*/}

                                    <HMRecordAudio
                                        onShow={this.onShow}
                                        hiddenModal={this.hiddenModal}
                                        setData={this.setData}
                                        _setStateData={this._setStateData}
                                        clearState={this.clearState}
                                        notFirstClear={true}

                                    />
                                    {/*      <TouchableOpacity
                            activeOpacity={1}
                            // onPress={() => {
                            //     this.setState(
                            //         {
                            //             playState: 'record',
                            //             visibleModal: "selectaudio",
                            //             Modalcategory: true,
                            //             showMessageInput: false,
                            //         },
                            //         () => {
                            //             // this.onShow("selectaudio")
                            //
                            //             // this._playWeb()
                            //
                            //         }
                            //     )
                            //
                            //
                            // }}
                            onPressIn={() => {
                                this.clearState();

                                //this.startAudio()
                                this.setState({onPressStatusVoice: true})
                                // this.func_switchOnPress = this.switchOnPress();
                                this.func_switchOnPress = this.startAudio();
                                this.setState({currentTime: 0},
                                    () => {
                                        this.timeout = setInterval(() => {
                                            if (container.state.currentTime === 0) {


                                            }
                                            if (container.state.currentTime >= 60) {
                                                //  this.switchOnPress();
                                                this.stopAudio();
                                            }
                                            else
                                                container.setState({
                                                    currentTime: container.state.currentTime + 1
                                                })
                                        }, 1000);
                                    }
                                )

                            }}
                            onPressOut={() => {
                                this.setState({onPressStatusVoice: false})

                                this.func_switchOnPress && this.func_switchOnPress.remove()
                                if (this.timeout) {
                                    clearInterval(this.timeout);
                                }

                                // if (this.state.playState !== "record" && this.mediaRecorder)
                                //     this.switchOnPress("onPressOut");
                                this.stopAudio();


                            }}

                            style={{
                                width: moderateScale(48),
                                height: moderateScale(48),
                                // backgroundColor: '#ee005b',
                                //position: 'absolute',
                                borderRadius: moderateScale(24),
                                margin: moderateScale(4),
                                //  top: 0,
                                //  left: 0,
                                alignItems: 'center',
                                justifyContent: 'center',
                                alignSelf: "center",
                            }}>
                            <View style={{
                                position: "absolute",
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                alignItems: "center",
                                justifyContent: "center",
                                opacity: .009
                            }}>
                                <AudioReactRecorder state={this.state.recordState} onStop={this.onStopAudio}
                                                    currentTime={this.state.currentTime}/>
                            </View>
                            <HMIcon
                                // type={""}
                                name={"mic"}
                                style={{
                                    textAlign: 'center',
                                    //alignSelf: 'flex-end',
                                    color: this.state.onPressStatusVoice ? Colors.red : Colors.blackLight,
                                    // width: moderateScale(32),
                                    // height: moderateScale(32),
                                    fontSize: moderateScale(this.state.onPressStatusVoice ? 48 : 36)
                                }}/>
                        </TouchableOpacity>*/}

                                    {
                                        (checkSeconds) ?

                                            <HMTextView

                                                // type={"bold"}
                                                noFont={!I18nManager.isRTL}
                                                style={{
                                                    fontSize: moderateScale(20),
                                                    color: Colors.blue,
                                                    margin: moderateScale(6)

                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={Tools.getAudioTimeStringMin(this.state.currentTime)}
                                                styleRoot={{}}
                                            />

                                            :
                                            null
                                    }

                                    {
                                        (checkSeconds) ?

                                            null

                                            :
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.clearState();
                                                    this.setState({
                                                        showMessageInput: !this.state.showMessageInput
                                                    })
                                                }}

                                                style={{
                                                    width: moderateScale(44),
                                                    height: moderateScale(44),
                                                    // backgroundColor: '#ee005b',
                                                    //position: 'absolute',
                                                    borderRadius: moderateScale(22),
                                                    // borderColor: Colors.gray,
                                                    // borderWidth: moderateScale(1),
                                                    margin: moderateScale(4),
                                                    //  top: 0,
                                                    //  left: 0,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    alignSelf: "center",

                                                }}>
                                                <HMIcon
                                                    // type={""}
                                                    name={"chatbox-outline"}
                                                    style={{
                                                        textAlign: 'center',
                                                        //alignSelf: 'flex-end',
                                                        color: Colors.blackLight,
                                                        // width: moderateScale(32),
                                                        // height: moderateScale(32),
                                                        fontSize: moderateScale(32)
                                                    }}/>
                                            </TouchableOpacity>
                                    }
                                    {
                                        (checkSeconds) ?

                                            null

                                            :
                                            <TouchableOpacity
                                                disabled={Platform.OS === "web"}
                                                onPress={() => {
                                                    this.clearState();

                                                    this.onShow("selectVideo")

                                                }}

                                                style={{
                                                    width: moderateScale(48),
                                                    height: moderateScale(48),
                                                    // backgroundColor: '#ee005b',
                                                    //position: 'absolute',
                                                    borderRadius: moderateScale(24),
                                                    margin: moderateScale(4),
                                                    //  top: 0,
                                                    //  left: 0,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    alignSelf: "center",
                                                }}>
                                                <HMIcon
                                                    // type={""}
                                                    name={"videocam"}
                                                    style={{
                                                        textAlign: 'center',
                                                        //alignSelf: 'flex-end',
                                                        color: Colors.blackLight,
                                                        // width: moderateScale(32),
                                                        // height: moderateScale(32),
                                                        fontSize: moderateScale(36)
                                                    }}/>
                                                <View
                                                    style={{
                                                        position: "absolute",
                                                        top: moderateScale(Platform.OS === "web" ? 16 : 18),
                                                        right: moderateScale(Platform.OS === "web" ? 10 : 12),
                                                        //   marginStart:moderateScale(20),
                                                        alignSelf: "center"
                                                    }}
                                                >
                                                    <HMIcon
                                                        type={"AntDesign"}
                                                        name={"plus"}
                                                        style={{
                                                            fontWeight: '900',
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.white,
                                                            // width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(14)
                                                        }}/>
                                                </View>

                                                {
                                                    <HMLabel
                                                        onClick={() => {
                                                            this.setState({
                                                                showMessageInput: false,
                                                            })
                                                        }}
                                                        onChange={(event) => this.fileSelect(event, "video")}

                                                        // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            bottom: 0,
                                                            left: 0,
                                                            right: 0,
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            opacity: .009
                                                        }}
                                                        type="file" accept="video/*"
                                                    />
                                                    /*  Platform.OS !== "web" ?
                                                      null
                                                      :
                                                      <label
                                                          onClick={() => {
                                                              this.setState({
                                                                  showMessageInput: false,
                                                              })
                                                          }}
                                                          onChange={(event) => this.fileSelect(event, "video")}

                                                          // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                                          style={{
                                                              position: "absolute",
                                                              top: 0,
                                                              bottom: 0,
                                                              left: 0,
                                                              right: 0,
                                                              alignItems: "center",
                                                              justifyContent: "center",
                                                              opacity: .009
                                                          }}>
                                                          <input type="file" accept="video/*"/>

                                                      </label>*/

                                                }
                                            </TouchableOpacity>
                                    }
                                    {
                                        (checkSeconds) ?

                                            null

                                            :
                                            <TouchableOpacity
                                                disabled={Platform.OS === "web"}
                                                onPress={() => {
                                                    this.clearState();

                                                    this.onShow("selectImage")
                                                }}

                                                style={{
                                                    width: moderateScale(48),
                                                    height: moderateScale(48),
                                                    // backgroundColor: '#ee005b',
                                                    //position: 'absolute',
                                                    borderRadius: moderateScale(24),
                                                    margin: moderateScale(4),
                                                    //  top: 0,
                                                    //  left: 0,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    alignSelf: "center",
                                                }}>
                                                <HMIcon
                                                    type={"MaterialCommunityIcons"}
                                                    name={"image-plus"}
                                                    style={{
                                                        textAlign: 'center',
                                                        //alignSelf: 'flex-end',
                                                        color: Colors.blackLight,
                                                        // width: moderateScale(32),
                                                        // height: moderateScale(32),
                                                        fontSize: moderateScale(36)
                                                    }}/>
                                                {
                                                    <HMLabel
                                                        onClick={() => {
                                                            this.setState({
                                                                showMessageInput: false,
                                                            })
                                                        }}
                                                        onChange={(event) => this.fileSelect(event, "image")}

                                                        // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            bottom: 0,
                                                            left: 0,
                                                            right: 0,
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            opacity: .009
                                                        }}
                                                        type="file" accept="image/*"
                                                    />
                                                    /*   Platform.OS !== "web" ?
                                                       null
                                                       :
                                                       <label
                                                           onClick={() => {
                                                               this.setState({
                                                                   showMessageInput: false,
                                                               })
                                                           }}
                                                           onChange={(event) => this.fileSelect(event, "image")}

                                                           // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                                           style={{
                                                               position: "absolute",
                                                               top: 0,
                                                               bottom: 0,
                                                               left: 0,
                                                               right: 0,
                                                               alignItems: "center",
                                                               justifyContent: "center",
                                                               opacity: .009
                                                           }}>
                                                           <input type="file" accept="image/!*"/>

                                                       </label>*/
                                                }
                                            </TouchableOpacity>
                                    }
                                    {
                                        (checkSeconds) || true ?

                                            null

                                            :
                                            <TouchableOpacity
                                                onPress={() => {
                                                    funcSwitch ? funcSwitch() : null
                                                }}

                                                style={{
                                                    width: moderateScale(48),
                                                    height: moderateScale(48),
                                                    // backgroundColor: '#ee005b',
                                                    //position: 'absolute',
                                                    borderRadius: moderateScale(24),
                                                    margin: moderateScale(4),
                                                    //  top: 0,
                                                    //  left: 0,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    alignSelf: "center",
                                                }}>
                                                <HMIcon
                                                    // type={""}
                                                    name={"settings"}
                                                    style={{
                                                        textAlign: 'center',
                                                        //alignSelf: 'flex-end',
                                                        color: Colors.blackLight,
                                                        // width: moderateScale(32),
                                                        // height: moderateScale(32),
                                                        fontSize: moderateScale(22)
                                                    }}/>
                                                <View
                                                    style={{
                                                        position: "absolute",
                                                        // top:moderateScale(16),
                                                        //  right:moderateScale(10),
                                                        //  alignSelf:"center"
                                                    }}
                                                >
                                                    <HMIcon
                                                        type={"AntDesign"}
                                                        name={"sync"}
                                                        style={{
                                                            fontWeight: '900',
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.blackLight,
                                                            // width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(34)
                                                        }}/>
                                                </View>
                                            </TouchableOpacity>
                                    }


                                </View>


                                {/*        <HMModal
                        isVisible={Platform.OS !== "web" && (this.state.visibleModal === 'selectImage' || this.state.visibleModal === 'selectVideo')}
                        backdropColor={Colors.gray}
                        backdropOpacity={0.8}
                        animationIn="zoomInDown"
                        animationOut="zoomOutUp"
                        animationInTiming={600}
                        animationOutTiming={600}
                        backdropTransitionInTiming={600}
                        backdropTransitionOutTiming={600}
                        //style={{height: '60%'}}
                        onBackdropPress={() => this.hiddenModal()}
                        onBackButtonPress={() => this.hiddenModal()}
                    >

                        <View style={{
                            //  height: "90%",
                            padding: moderateScale(6),
                            backgroundColor: Colors.white
                        }}>
                            {
                                this.state.visibleModal === "selectImage" ?

                                    <View>
                                        <TouchableOpacity
                                            onPress={() => {
                                                ImagePicker.openCamera(optional).then(image => {
                                                    //   alert((image.size / 1048576).toFixed(2) + " mb")
                                                    this.state.arrImage.push(image.path)
                                                    //        this.props.func("arrImage", this.state.arrImage)

                                                    this.setState({
                                                            pathImage: image.path,
                                                            visibleModal: '',
                                                            showMessageInput: true,

                                                        },
                                                        () => {
                                                            // this.setData()
                                                        })
                                                });
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#eee',
                                                margin: moderateScale(5),
                                                padding: moderateScale(8),
                                                borderRadius: moderateScale(4)
                                            }}>
                                            <HMTextView
                                                text={"گرفتن عکس"}
                                                type={'bold'}
                                                style={{
                                                    alignSelf: 'center',
                                                    //  marginRight: moderateScale(6),
                                                    // margin: moderateScale(6),
                                                    textAlign: 'center',
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(14),
                                                }}/>
                                        </TouchableOpacity>
                                        <TouchableOpacity
                                            onPress={() => {
                                                ImagePicker.openPicker({
                                                    width: 1000,
                                                    height: 1000,
                                                    cropping: true
                                                }).then(image => {
                                                    this.state.arrImage.push(image.path)

                                                    this.setState({
                                                            showMessageInput: true,
                                                            //ShowImage:true
                                                            visibleModal: '',
                                                            pathImage: image.path
                                                        },
                                                        () => {
                                                            //this.setData()
                                                        }
                                                    )
                                                });
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#eee',
                                                padding: moderateScale(8),
                                                margin: moderateScale(5),
                                                borderRadius: moderateScale(4)
                                            }}>
                                            <HMTextView
                                                text={"انتخاب عکس از گالری"}
                                                type={'bold'}
                                                style={{
                                                    alignSelf: 'center',
                                                    //  marginRight: moderateScale(6),
                                                    // margin: moderateScale(6),
                                                    textAlign: 'center',
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(14),
                                                }}/>
                                        </TouchableOpacity>
                                    </View>
                                    :
                                    <View>
                                        <TouchableOpacity
                                            onPress={() => {
                                                ImagePicker.openCamera({
                                                    mediaType: 'video',
                                                }).then(video => {


                                                    this.compressVideo(video)

                                                });
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#eee',
                                                margin: moderateScale(5),
                                                padding: moderateScale(8),
                                                borderRadius: moderateScale(4)
                                            }}>
                                            <HMTextView
                                                text={"گرفتن فیلم"}
                                                type={'bold'}
                                                style={{
                                                    alignSelf: 'center',
                                                    //  marginRight: moderateScale(6),
                                                    // margin: moderateScale(6),
                                                    textAlign: 'center',
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(14),
                                                }}/>
                                        </TouchableOpacity>
                                        <TouchableOpacity
                                            onPress={() => {
                                                ImagePicker.openPicker({
                                                    mediaType: "video",
                                                }).then((video) => {

                                                    this.compressVideo(video)
                                                });
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#eee',
                                                padding: moderateScale(8),
                                                margin: moderateScale(5),
                                                borderRadius: moderateScale(4)
                                            }}>
                                            <HMTextView
                                                text={"انتخاب فیلم از گالری"}
                                                type={'bold'}
                                                style={{
                                                    alignSelf: 'center',
                                                    //  marginRight: moderateScale(6),
                                                    // margin: moderateScale(6),
                                                    textAlign: 'center',
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(14),
                                                }}/>
                                        </TouchableOpacity>
                                    </View>
                            }


                        </View>
                    </HMModal>*/}

                            </View>
                    }

                    <HMModalSelectFiles
                        isVisible={this.state.visibleModal}

                        arrImageFunc={(path) => {
                            //   container.state.arrImage.push(path);
                        }}
                        onShow={this.onShow}
                        hiddenModal={() => this.hiddenModal()}
                        setDataFunc={this.setData}
                        _setStateData={this._setStateData}
                        _setStateDataParent={this.props._setStateData}
                        clearState={this.clearState}

                    />
                    {
                        this.state.isLoadingCompress ?
                            <DialogLoadingCustomize
                                text={"درحال کاهش حجم فایل"}
                            />
                            :
                            null
                    }
                </View>
            </View>


        );
    }

    renderItemIcon = (item, index, menuState) => {
        const {itemsDown, dimmerActive} = menuState;

        const isItemPressed = itemsDown[index];
        const color = isItemPressed ? '#fff' : Colors.white;

        // Icons can be rendered however you like.
        // Here are some examples, using data from the item object:
        if (item.icon) {
            return (
                <TouchableOpacity
                    onPress={() => {
                        if (item.type == 1)
                            this._setStateData({
                                isMenuOpen: false,
                                showMessageInput: true,
                                taskType: "doing"
                            })
                        else {
                            this._setStateData({
                                isMenuOpen: false,
                                showMessageInput: true,
                                taskType: "done"
                            })
                        }
                    }}
                >
                    <HMIcon
                        type={item.typeIcon}
                        name={item.icon}
                        style={{
                            textAlign: 'center',
                            //alignSelf: 'flex-end',
                            color: color,
                            // width: moderateScale(32),
                            // height: moderateScale(32),
                            fontSize: moderateScale(32)
                        }}/>
                </TouchableOpacity>
            );
        }
        else if (item.image) {
            return (
                <Image
                    source={item.image}
                    style={{
                        height: moderateScale(36),
                        width: moderateScale(36),
                        tintColor: color,

                    }}
                    resizeMode="contain"
                />
            );
        }

        return null;
    };

    renderMenuIcon = (menuState) => {
        const {menuButtonDown, dimmerActive} = menuState;
        return dimmerActive ? <HMIcon
                type={"AntDesign"}
                name={"close"}
                style={{
                    textAlign: 'center',
                    //alignSelf: 'flex-end',
                    color: Colors.white,
                    // width: moderateScale(32),
                    // height: moderateScale(32),
                    fontSize: moderateScale(32)
                }}/>
            : <HMIcon
                type={"Entypo"}
                name={"menu"}

                style={{
                    textAlign: 'center',
                    //alignSelf: 'flex-end',
                    color: Colors.white,
                    // width: moderateScale(32),
                    // height: moderateScale(32),
                    fontSize: moderateScale(32)
                }}/>;
    }

    SwitchFile() {

        if (this.state.pathImage)
            return <HMLightbox
                uri={Platform.OS === "web" ? URL.createObjectURL(this.state.pathImage) : this.state.pathImage}/>;
        else if (this.state.pathVideo) {
            return <HMVideo
                styleRoot={{
                    //   aspectRatio: 1 / 2,
                    width: '100%',
                }}
                path={Platform.OS === "web" ? URL.createObjectURL(this.state.pathVideo) : this.state.pathVideo}
                //  path={"https://file-examples.com/storage/fe784cece4625207f9e5b9d/2017/04/file_example_MP4_480_1_5MG.mp4"}
            />

            // return <HMVideo
            //     styleRoot={{
            //         width: "100%",
            //         height: moderateScale(280),
            //     }}
            //     path={Platform.OS === "web" ? URL.createObjectURL(this.state.pathVideo) : this.state.pathVideo}/>
        }
        else if (this.state.ShowAudio) {
            return <HMVoicePlayer SeekBarCheck={true} path={this.state.audioPath}/>
        }
    }

    clearState() {
        descriptionValue = null;
        this.valueRef?.clear()
        container.setState({
                showMessageInput: false,
                description: null,
                pathImage: null,
                pathVideo: null,
                ShowAudio: null,
                arrImage: [],


                audioPath: Platform.OS === "web" ? null : container.state.audioPath,
                audioBlob: null,


                listName: [],
                SelectRollValue: null,
                showSelectInputCCTask: false,
                showSelectInputRollBack: false,
                showSelectInputRoll: false,
            },
            () => {
            }
        )
    }

    /*  nextTask() {
          let {item, type, indexExtra, itemExtra, pageDetails, itemExtraParent,} = container.props.dataExtra;
          let {listTask} = container.props;

          if (listTask.length > indexExtra + 1) {
              NavigationService.replace("DetailsTaskOperationSatiaScreen", {
                  item: listTask[indexExtra + 1],
                  itemExtra: listTask[indexExtra + 1],
                  itemExtraParent: itemExtraParent,
                  // type: type,
                  indexExtra: indexExtra + 1
              })
          }


      }
  */
    setData() {

        container.setState({showMessageInput: false})
        let {funcAddStateItemExtra, indexExtra, itemExtra, itemExtraFirst, funcNext} = container.props;
        let {description, listName, SelectRollValue, taskType} = container.state;

        if (taskType == "done" || (listName?.length > 0) || SelectRollValue) {
            container.props._setStateData({
                isLoadingSet: true
            })
        }


        let params = {
            //"comment": container.state.description,
            "arrImage": container.state.arrImage,
            "image": container.state.pathImage,
            "video": container.state.pathVideo,
            "audio": container.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + container.state.audioPath : container.state.audioPath) : null,
            "audioBlob": container.state.ShowAudio && Platform.OS === "web" ? (container.state.audioBlob) : null,
            "durationVoice": container.state.ShowAudio ? (container.state.durationVoice) : null,


            "title": itemExtraFirst.Title,
            "taskRef": itemExtraFirst.Serial,
            "description": description,
            "status": 0,
            "ccTo": JSON.stringify(listName),
            "referTo": SelectRollValue ? SelectRollValue : null,
            "taskType": taskType ? taskType : null,

        }
        RequestApi.requestAddCommentSatia(params, (data, response) => {
            // store.dispatch(serviceActionAddComment(data, container.props.indexExtra))
            container.clearState();
            container.props._setStateData({
                isLoadingSet: false
            })

            if (data && data.status) {
                global._refreshSplashSatiaOperator = true;
                if (data.done) {
                    container.props.listTask.splice(indexExtra, 1);
                    funcNext ? funcNext(data.done) : null;
                    // global._refreshListTaskOperationSatia=true;
                    //  NavigationService.Pop();

                }

                else {
                    if (SelectRollValue != null && container.props.user.OpRef != SelectRollValue) {
                        container.props.listTask.splice(indexExtra, 1);
                        funcNext ? funcNext() : NavigationService.Pop();
                        // NavigationService.Pop();
                    }
                    else {
                        funcAddStateItemExtra ? funcAddStateItemExtra(data, response) : null;

                    }
                }
            }
            else {
                Toast.show({
                    // type: 'success | error | info',
                    type: 'custom_error',
                    //  position: 'top | bottom',
                    position: 'top',
                    text1: i18n.t('constant.message'),
                    text2: data && data.message ? data.message : "سرور با خطا مواجه شد مجددا تلاش نمایید",
                    visibilityTime: 4000,
                    autoHide: true,
                    //  topOffset: 30,
                    // bottomOffset: 40,
                    onShow: () => {
                    },
                    onHide: () => {
                    }
                })
            }


        }, () => {
            container.props._setStateData({
                isLoadingSet: false
            })
        });
    }

    fileSelect = async (event, type) => {
        // NavigationService.BackTo(2)

        // this.uploadFile(image, true)


        let nameState = "";
        let path = type ? event.target.files[0] : await Tools.resizeFile(event.target.files[0]);
        switch (type) {

            case "image":
                nameState = "pathImage";
                this.state.arrImage.push(path);
                break;

            case "video":
                nameState = "pathVideo";
                break;

            default:

        }
        this.setState({
                //ShowImage:true
                visibleModal: '',
                [nameState]: path,
                showMessageInput: true
            },

            () => {
                // if (type)
                //     this.setData()
            }
        )
    }

}

const mapStateToProps = (state) => {

    return {
        user: state.reducerSplashSatiaScreen.user,
        listTask: state.reducerListTaskOperationSatiaScreen?.results,

    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(HMBottomBarItemSatiaOperator);
